import { Route, Routes } from 'react-router-dom';
import AgreementList from './AgreementList';
import AgreementView from './AgreementView';
import AgreementDashBoard from './AgreementDashBoard';
import Reports from './Reports';

function AgreementRoutes() {
  return (
    <Routes>
      <Route path="dashboard" element={<AgreementDashBoard />} />
      <Route path="agreement-list" element={<AgreementList />} />
      <Route path="agreement-list/:agreementId" element={<AgreementView />} />
      <Route path="reports" element={<Reports />} />
    </Routes>
  );
}

export default AgreementRoutes;
